import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/utils/tailwind.util';
import { CheckCircleUI } from './CheckCircleUI';
type AnswerControlProps = {
  isChecked: boolean;
  onToggle: () => void;
  disabled?: boolean;
} & ComponentPropsWithoutRef<'div'>;
export const AnswerControl = forwardRef<HTMLDivElement, AnswerControlProps>(({
  isChecked,
  onToggle,
  disabled,
  ...props
}, ref) => {
  return <div ref={ref} {...props}>
        <CheckCircleUI.Container className={cn(isChecked && 'bg-green-500', !isChecked && 'bg-gray-200', disabled && 'opacity-[0.54]')} onClick={e => {
      e.stopPropagation();
      if (disabled) return;
      onToggle();
    }}>
          {isChecked && <CheckCircleUI.Icon />}
        </CheckCircleUI.Container>
      </div>;
});